'use client';

import { useState, useEffect } from 'react';
import styles from './ProfessionalPacks.module.css';
import { Link } from 'react-router-dom';
import basedGetUrlRequestLogedIn from '../../util/apiRequests/basedGetUrlRequestLogedIn';

const defaultImage =
  'https://sharetribe.imgix.net/6644cdce-c443-44fc-a95e-d3abbca7a3b9/667d7d2a-5050-4c12-87ae-ce8e30c0fec7?auto=format&fit=clip&h=2400&w=2400&s=d9834d8017f124e381cdd4e21a3e2b6f';

export default function ProfessionalPacks() {
  const [packs, setPacks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPacks = async () => {
      try {
        const response = await basedGetUrlRequestLogedIn('/api/listings-with-pack');
        if (response && response.data) {
          setPacks(response.data);
        }
      } catch (error) {
        console.error('Error fetching packs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPacks();
  }, []);

  if (loading) {
    return <div className={styles.container}>Cargando packs...</div>;
  }

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Explora nuestros packs para profesionales</h2>
      <div className={styles.scrollContainer}>
        {/* Pack Vlogger */}
        <div className={styles.card}>
          <div className={styles.productSectionGredients}>
            <h3 className={styles.cardTitle}>Pack Vlogger ya disponible</h3>
            <div className={styles.productSection}>
              {packs.slice(0, 3).map((item, i) => (
                <div className={styles.product} key={i}>
                  <img
                    src={item.img || '/placeholder.svg'}
                    alt={item.img}
                    className={styles.image}
                  />
                  <span className={styles.productName}>{item.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.infoRow}>
            <div>
              <h3 className={styles.cardSubTitle}>Pack Vlogger</h3>
              <p className={styles.description}>
                Perfecto para grabarte en la calle, viajes o crear contenido personal.
              </p>
            </div>
            <button className={styles.button}>
              <Link to="/s">Alquilar pack</Link>
            </button>{' '}
          </div>
        </div>

        {/* Pack Cine */}
        <div className={styles.card}>
          <div className={styles.productSectionGredients}>
            <h3 className={styles.cardTitle}>Calidad cinematográfica</h3>
            <div className={styles.productSection}>
              {packs.slice(3, packs.length).map((item, i) => (
                <div className={styles.product} key={i}>
                  <img
                    src={item.img || '/placeholder.svg'}
                    alt={item.img}
                    className={styles.image}
                    onError={handleImageError}
                  />
                  <span className={styles.productName}>{item.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.infoRow}>
            <div>
              <h3 className={styles.cardSubTitle}>Review Tech Express</h3>
              <p className={styles.description}>
                Perfecto para unboxings, reseñas de productos y vídeos tecnológicos.{' '}
              </p>
            </div>

            <button className={styles.button}>
              <Link to="/s">Alquilar pack</Link>
            </button>

            {/* <InlineTextButton>Alquirrar</InlineTextButton> */}
          </div>
        </div>
      </div>
    </div>
  );
}
